import { useTranslation } from "react-i18next";
import type { RankingEntityType } from "../hooks/useRankingData";

interface RankingSubTabsProps {
  activeTab: RankingEntityType;
  onTabChange: (tab: RankingEntityType) => void;
  showGroupTabs?: boolean;
}

const RankingSubTabs = ({ activeTab, onTabChange, showGroupTabs = false }: RankingSubTabsProps) => {
  const { t } = useTranslation();

  const baseTabs: { key: RankingEntityType; label: string }[] = [
    { key: "parcours", label: t("statsNew.classement.subTabs.parcours") },
    { key: "modules", label: t("statsNew.classement.subTabs.modules") },
    { key: "apprenants", label: t("statsNew.classement.subTabs.apprenants") },
  ];

  const groupTabs: { key: RankingEntityType; label: string }[] = [
    { key: "groupes", label: t("statsNew.classement.subTabs.groupes") },
    { key: "groupes_parcours", label: t("statsNew.classement.subTabs.groupesParcours") },
  ];

  const tabs = showGroupTabs ? [...baseTabs, ...groupTabs] : baseTabs;

  return (
    <div className="inline-flex bg-gray-100 rounded-lg p-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
            activeTab === tab.key
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default RankingSubTabs;
